import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/app/shared.module";

@Component({
  selector: "app-voucher-return-amounts",
  templateUrl: "./voucher-return-amounts.component.html",
  standalone: true,
  imports: [CommonModule, TranslateModule, SharedModule],
})
export class VoucherReturnAmountsComponent {
  @Input() maxGift: number = 0;
  @Input() maxBenefit: number = 0;
  @Input() showGift = true;
}
